import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"

const Cocurricular = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="Co-Curricular Activities" midBreadcrumb="Academic" mainBreadcrumb="Co-Curricular Activities" ></Breadcrumb>
            <div className='inner-page'>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="mainhead">Co-Curricular Activities</h2>
                            <h3 className="subhead">Mere accumulation of knowledge is not enough in life.</h3>
                            <p><strong>Some of the co-curricular activities encouraged are:</strong></p>
                        </div>
                    </div>
                    <div className="row g-3">

                        <div className="col-xxl-4 col-xl-6 col-12">
                            <div className="curri timeline">
                                <ul className="listview">
                                    <li>Public speaking (English, Hindi and Punjabi)</li>
                                    <li>Dramatics</li>
                                    <li>Social service</li>
                                    <li>Drawing and painting</li>
                                    <li>Dancing and singing games</li>
                                    <li>Excursions</li>
                                    <li>Educational films</li>
                                    <li>Work experience</li>
                                    <li>Leadership Training Service</li>
                                    <li>Scouting and Guiding</li>
                                    <li>Karate</li>
                                    <li>Basketball</li>
                                    <li>Football</li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-xxl-4 col-xl-6 col-12">
                            <div className="curri timeline">
                                <ul className="listview">
                                    <li>Kho – kho</li>
                                    <li>Table tennis</li>
                                    <li>Chess</li>
                                    <li>Carom</li>
                                    <li>Save Earth Unit</li>
                                    <li>Consumer Protection Club</li>
                                    <li>Ladies &amp; gentleman Club</li>
                                    <li>Health &amp; hygiene</li>
                                    <li>Safety &amp; security</li>
                                    <li>Science Exhibition</li>
                                    <li>School Band.</li>
                                    <li>Bulletin Board competitions.</li>
                                    <li>Annual School Magazine.</li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-xxl-4 col-xl-6 col-12">
                            <div className="curri timeline">
                                <ul className="listview">
                                    <li>Activities under the Aegis of Sahodaya (CBSE) Schools of Indore.</li>
                                    <li>Activities under the Aegis of Parent Teacher Association.</li>
                                    <li>Activities under the Aegis of ICSA.</li>
                                    <li>Value Education and Life Skills Activities.</li>
                                    <li>Awareness Programmes on Social and Civic Issues.</li>
                                    <li>Celebration of Major Festivals.</li>
                                    <li>Career Guidance Programmes.</li>
                                    <li>Olympiads, Tests and Competitions.</li>
                                    <li>Daily News Reading.</li>
                                    <li>Intra – House / Inter – house / Inter – house Cultural and Literary Activities.</li>
                                    <li>Intra – House / Inter House / Inter – School Sports and Games activities.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Cocurricular